module.exports = __webpack_public_path__ + "static/images/insights.8f0dfbd56066d9e99665517d9bdec3ff.svg";